const STORAGE_KEY = 'admindesk_last_api_failure';

export type ApiFailureBreadcrumb = {
  kind: 'network' | 'http401' | 'http_other' | 'parse' | 'profile';
  url: string;
  detail?: string;
  status?: number;
  at: string;
};

function safeJson(obj: ApiFailureBreadcrumb): string {
  try {
    const s = JSON.stringify(obj);
    return s.length > 1800 ? s.slice(0, 1800) + '…' : s;
  } catch {
    return JSON.stringify({ kind: 'parse', url: '', at: new Date().toISOString() });
  }
}

/** Grava motivo da falha antes de redirecionar (para ler na rota /login). */
export function recordApiFailureBreadcrumb(info: Omit<ApiFailureBreadcrumb, 'at'>): void {
  try {
    const payload: ApiFailureBreadcrumb = {
      ...info,
      at: new Date().toISOString(),
    };
    sessionStorage.setItem(STORAGE_KEY, safeJson(payload));
  } catch {
    /* ignore quota */
  }
}

/** Lê e remove o último breadcrumb (uma vez por montagem da tela de login). */
export function consumeApiFailureBreadcrumb(): ApiFailureBreadcrumb | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const o = JSON.parse(raw) as ApiFailureBreadcrumb;
    if (!o || typeof o.kind !== 'string') return null;
    return o;
  } catch {
    return null;
  }
}
